import { render, staticRenderFns } from "./remittance-record.vue?vue&type=template&id=6277bcc8&scoped=true&"
import script from "./remittance-record.vue?vue&type=script&lang=js&"
export * from "./remittance-record.vue?vue&type=script&lang=js&"
import style0 from "./remittance-record.vue?vue&type=style&index=0&id=6277bcc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6277bcc8",
  null
  
)

export default component.exports